// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-list__error-text,.van-list__finished-text,.van-list__loading{color:#969799;font-size:1.867vw;line-height:6.667vw;text-align:center}.van-list__placeholder{height:0;pointer-events:none}", ""]);
// Exports
module.exports = exports;
